import dayjs from 'dayjs';

export interface Token {
    token: string;
    created: dayjs.Dayjs;
    id: number;
    status: number;
    name: string;
}

export interface ApiState {
    tokens: Array<Token>;
    fetch: boolean;
}

export const initialState: Readonly<ApiState> = {
    tokens: [],
    fetch: true,
};

export interface TokenResponse {
    API_TOKEN: string;
    CREATED: string;
    ID: number;
    STATUS: number;
    TOKEN_NAME: string;
}

export const mapToken = ({ API_TOKEN, CREATED, ID, STATUS, TOKEN_NAME }: TokenResponse): Token => ({
    token: API_TOKEN,
    id: ID,
    created: dayjs(CREATED),
    name: TOKEN_NAME,
    status: STATUS,
});
